export default {
    limited_action_line: {
        name: "Limited Action Line",
        url: "nwcg_lines_strategic_operation/limited_action_line",
    },
    primary_strategic_line: {
        name: "Primary Strategic Line",
        url: "nwcg_lines_strategic_operation/primary_strategic_line",
    },
    proposed_strategic_line: {
        name: "Proposed Strategic Line",
        url: "nwcg_lines_strategic_operation/proposed_strategic_line",
    },
    secondary_strategic_line: {
        name: "Secondary Strategic Line",
        url: "nwcg_lines_strategic_operation/secondary_strategic_line",
    },
}
